import React, { useContext, useMemo, useState, useEffect } from 'react';
import { preloadImages } from '../../utils';
import { LoginImages, LogoImages } from '../../assets/images';
import LoadingFallback from './LoadingFallback';

interface LoadingFallbackContextProps {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LoadingFallbackContext =
  React.createContext<LoadingFallbackContextProps>(
    {} as LoadingFallbackContextProps,
  );

export const useLoadingFallback = () => useContext(LoadingFallbackContext);

const LoadingFallbackProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    preloadImages([
      LoginImages.loginBackground.default,
      LogoImages.cyphlensLogo.default,
      LoginImages.recoverIcon.default,
      LoginImages?.lockIcon.default,
      LogoImages?.cyphlens.default,
    ]);
  }, []);

  const contextValue = useMemo(
    () => ({ loading, setLoading }),
    [loading, setLoading],
  );
  return (
    <LoadingFallbackContext.Provider value={contextValue}>
      {children}
      {loading && <LoadingFallback />}
    </LoadingFallbackContext.Provider>
  );
};

export default LoadingFallbackProvider;
